import api from 'api';

export const loadNewsList = api('GET /api/news/list');
export const createNews = api('POST /api/news');
export const updateNews = api('PUT /api/news/:id');
export const deleteNews = api('DELETE /api/news/:id');

export const updateRelease = api('PUT /api/news/release');
export const loadRelease = api('GET /api/news/release');
export const loadTypes = api('GET /api/news/types');
